/*global Modernizr, tec_search_form_field_show, tec_search_form_field_hide */
/*jslint browser:true */

(function() {
  'use strict';

  var form_1295_cert = document.getElementById('tec-1295-search-cert'),
      form_1295_entity = document.getElementById('tec-1295-search-entity');

  if(form_1295_cert) {
    var field_cert_type = form_1295_cert.querySelector('#form-cert-search-type'),
        field_cert_certificate = form_1295_cert.querySelector('#field-cert-certificate'),
        field_cert_contract = form_1295_cert.querySelector('#field-cert-contract');

    field_cert_type.addEventListener('change', (e) => {
      // Fallback for browsers that don't support View Transitions:
      if (!document.startViewTransition) {
        check_1295_cert_form();
      } else {
        document.startViewTransition(() => check_1295_cert_form());
      }
    });

    setTimeout(function() {
      check_1295_cert_form();
    }, 100);
  }

  if(form_1295_entity) {
    var field_entity_type = form_1295_entity.querySelector('#form-entity-search-type'),
        field_entity_business = form_1295_entity.querySelector('#field-entity-business'),
        field_entity_government = form_1295_entity.querySelector('#field-entity-government'),
        field_entity_agency = form_1295_entity.querySelector('#field-entity-agency'),
        field_entity_interested = form_1295_entity.querySelector('#field-entity-interested');

    field_entity_type.addEventListener('change', (e) => {
      // Fallback for browsers that don't support View Transitions:
      if (!document.startViewTransition) {
        check_1295_expenditure_form();
      } else {
        document.startViewTransition(() => check_1295_expenditure_form());
      }
    });

    setTimeout(function() {
      check_1295_expenditure_form();
    }, 100);
  }

  function check_1295_cert_form() {
    if(field_cert_type.value === 'certificate') {
      tec_search_form_field_show(field_cert_certificate);
      tec_search_form_field_hide(field_cert_contract);
    } else if(field_cert_type.value === 'contract') {
      tec_search_form_field_hide(field_cert_certificate);
      tec_search_form_field_show(field_cert_contract);
    } else {
      tec_search_form_field_hide(field_cert_certificate);
      tec_search_form_field_hide(field_cert_contract);

    }
  }

  function check_1295_expenditure_form() {
    if(field_entity_type.value === 'business') {
      tec_search_form_field_show(field_entity_business);
      tec_search_form_field_hide(field_entity_government);
      tec_search_form_field_hide(field_entity_agency);
      tec_search_form_field_hide(field_entity_interested);
    } else if(field_entity_type.value === 'government') {
      tec_search_form_field_hide(field_entity_business);
      tec_search_form_field_show(field_entity_government);
      tec_search_form_field_hide(field_entity_agency);
      tec_search_form_field_hide(field_entity_interested);
    } else if(field_entity_type.value === 'agency') {
      tec_search_form_field_hide(field_entity_business);
      tec_search_form_field_hide(field_entity_government);
      tec_search_form_field_show(field_entity_agency);
      tec_search_form_field_hide(field_entity_interested);
    } else if(field_entity_type.value === 'interested') {
      tec_search_form_field_hide(field_entity_business);
      tec_search_form_field_hide(field_entity_government);
      tec_search_form_field_hide(field_entity_agency);
      tec_search_form_field_show(field_entity_interested);
    } else {
      tec_search_form_field_hide(field_entity_business);
      tec_search_form_field_hide(field_entity_government);
      tec_search_form_field_hide(field_entity_agency);
      tec_search_form_field_hide(field_entity_interested);
    }
  }
}());
